











































































































































































































































import BaseComponent from '@/components/base-component.vue';
import PlannerItemForm from '@/components/crm/adm-planner/planner-item-form.vue';
import CalendarVisitFilters from '@/components/crm/calendar/calendar-visit-filters.vue';
import VisitPlanningCycle from '@/components/crm/visit-planning/visit-planning-cycle.vue';
import VisitPlanningForm from '@/components/crm/visit-planning/visit-planning-form.vue';
import VisitForm from '@/components/crm/visit/visit-form.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import { CrmCalendarioFiltrosDTO } from '@/interfaces/crm-calendar';
import * as service from '@/services/crm-calendar';
import { getServerISODate } from '@/services/utils';
import moment from 'moment';
import Component from 'vue-class-component';

@Component({
  components: {
    VisitPlanningCycle,
    UiDatePicker,
    VisitPlanningForm,
    VisitForm,
    PlannerItemForm,
    UiFilterContainer,
    CalendarVisitFilters
  }
})
export default class Calendar extends BaseComponent {
  focus = null;
  type = 'month';
  start = null;
  end = null;
  typeOptions = [
    { text: 'Dia', value: 'day' },
    { text: 'Semana', value: 'week' },
    { text: 'Mês', value: 'month' }
  ];

  title = '';
  today = null;
  items = [];
  itemsMap = {};

  itemSelec = null;
  showMenu = false;
  menuX = 0;
  menuY = 0;

  formOpen = false;
  planning = false;
  formPlannerOpen = false;
  idSelected = null;
  date = null;
  edit = false;

  cycle = null;

  public $refs!: {
    form: HTMLFormElement;
  };

  buildItemsMap() {
    const map = {};
    this.items.forEach((e) => (map[e.date] = map[e.date] || []).push(e));
    this.itemsMap = map;
  }

  intervalLoad = null;
  mounted() {
    getServerISODate().subscribe((res) => {
      this.start = res;
      this.today = res;
    });

    this.intervalLoad = setInterval(() => {
      this.loadLastFilter(true);
    }, 180000);
  }

  beforeDestroy() {
    clearInterval(this.intervalLoad);
  }

  previous() {
    this.$refs['calendar'].prev();
  }

  next() {
    this.$refs['calendar'].next();
  }

  onCycleLoaded(cycle) {
    if (cycle == null) {
      return;
    }
    this.cycle = cycle;
    this.type = 'month';
  }

  openMenuItem(item, e) {
    this.itemSelec = item;
    this.menuX = e.clientX + 20;
    this.menuY = e.clientY;
    this.itemSelec.key = Math.random();
    setTimeout(() => {
      this.showMenu = true;
    }, 50);
  }

  onCalendarChange(v) {
    this.load(v.start.date, v.end.date);
    if (this.type == 'month') {
      this.title = moment(v.start.date).locale('pt-br').format('MMMM/YYYY');
    } else {
      this.title = this.dateFormatHelper(v.start.date, 'BR');
      if (v.start.date != v.end.date) {
        this.title += ' a ' + this.dateFormatHelper(v.end.date, 'BR');
      }
    }
  }

  public onFilter(value): void {
    this.lastFilter.idsVisitantes = value.idsVisitantes;
    this.loadLastFilter();
  }

  lastFilter: CrmCalendarioFiltrosDTO = null;

  load(start?, end?) {
    let f = new CrmCalendarioFiltrosDTO();
    if (this.type == 'month') {
      f.inicio = start ? moment(start).subtract(7, 'days').format('YYYY-MM-DD') : null;
      f.fim = end ? moment(end).add(7, 'days').format('YYYY-MM-DD') : null;
    } else {
      f.inicio = start;
      f.fim = end;
    }
    if (!this.loadFlag) {
      if (this.lastFilter.inicio == f.inicio) {
        return;
      }
    }
    if (!!this.lastFilter) {
      f.idsVisitantes = this.lastFilter.idsVisitantes;
    }
    this.itemsMap = [];
    this.lastFilter = f;
    this.loadLastFilter();
  }

  loadLastFilter(quiet = false) {
    if (!quiet) {
      this.loader.start('processando ...');
    }
    service.listCrmCalendarItems(this.lastFilter).subscribe(
      (res) => {
        this.loader.stop();
        this.items = res.map((i) => {
          return {
            ...i,
            title: i.titulo,
            fullTitle: i.titulo + (i.individual ? ': ' + i.participantes : ''),
            date: i.data,
            time: i.hora,
            duration: i.duracaoMinutos ? i.duracaoMinutos : 30,
            key: Math.random()
          };
        });
        this.buildItemsMap();
      },
      (error) => {
        this.loader.stop();
        this.showToastApiError(error);
      }
    );
  }

  viewItem(item) {
    this.idSelected = item.id;
    this.date = null;
    this.planning = item.agendamento;
    this.edit = false;
    if (item.agendaInterna) {
      this.formPlannerOpen = true;
    } else {
      this.formOpen = true;
    }
  }

  editItem(item) {
    this.idSelected = item.id;
    this.date = null;
    this.planning = item.agendamento;
    this.edit = true;
    if (item.agendaInterna) {
      this.formPlannerOpen = true;
    } else {
      this.formOpen = true;
    }
  }

  onCloseForm() {
    this.formOpen = false;
    this.formPlannerOpen = false;
    this.idSelected = null;
    this.date = null;
    this.edit = false;
  }

  onAfterSave() {
    this.onCloseForm();
    this.loadLastFilter();
  }

  loadFlag = true;
  onClickDate(v) {
    this.loadFlag = false;
    let item = {
      title: this.dateFormatHelper(v.date, 'BR') + (this.isClosed(v.date) ? ' (Ciclo fechado)' : ''),
      data: v.date,
      key: Math.random()
    };
    this.itemSelec = item;
    setTimeout(() => {
      this.loadFlag = true;
    }, 1000);
  }

  addVisit(item) {
    this.idSelected = null;
    this.date = item.data;
    this.planning = false;
    this.edit = true;
    this.formOpen = true;
  }

  addPlanning(item) {
    this.idSelected = null;
    this.date = item.data;
    this.planning = true;
    this.edit = true;
    this.formOpen = true;
  }

  addItemPlanner(item) {
    this.idSelected = null;
    this.date = item.data;
    this.planning = false;
    this.edit = true;
    this.formPlannerOpen = true;
  }

  isClosed(date) {
    if (!this.cycle) {
      return false;
    }
    return moment(this.cycle.dataMinPermitida).isAfter(date);
  }

  canPlanning(item) {
    return !this.isClosed(item.data) && this.hasPermission([this.permissionsKeys.CRM_VISIT_PLANNING_EDIT]);
  }

  canRegister(item) {
    return (
      !moment(item.data).isAfter(this.today) &&
      this.hasPermission([this.permissionsKeys.CRM_VISIT_EDIT]) &&
      !moment(this.cycle.dataLimiteLancVisita).isAfter(moment(item.data))
    );
  }

  canAddItemPlanner(item) {
    return this.hasPermission([this.permissionsKeys.CRM_PLANNER_ITEM_INSERT]);
  }

  canView(item) {
    return (
      (item.agendaInterna && this.hasPermission([this.permissionsKeys.CRM_PLANNER_ITEM_VIEW])) ||
      (item.agendamento && this.hasPermission([this.permissionsKeys.CRM_VISIT_PLANNING_VIEW])) ||
      (!item.agendamento && this.hasPermission([this.permissionsKeys.CRM_VISIT_VIEW]))
    );
  }

  canAlter(item) {
    if (!item.podeAlterar) {
      return false;
    }

    return (
      (item.agendaInterna && this.hasPermission([this.permissionsKeys.CRM_PLANNER_ITEM_EDIT])) ||
      (item.agendamento && this.hasPermission([this.permissionsKeys.CRM_VISIT_PLANNING_EDIT])) ||
      (!item.agendamento && this.hasPermission([this.permissionsKeys.CRM_VISIT_EDIT]))
    );
  }
}
